// extracted by mini-css-extract-plugin
module.exports = {"img":"CampaignBrief__img___2T4TE","single":"CampaignBrief__single___2rFYR"};